import { MyProfile } from '@/types/my-profile.type';

export type MyProfileResponse = {
  user: {
    id: string;
    first_name?: string | null;
    last_name?: string | null;
    email?: string | null;
    phone?: string | null;
    photo_url?: string | null;
    role?: string | null;
  };
  profile: {
    city?: string | null;
    state?: string | null;
    zip_code?: string | null;
    address?: string | null;
    linkedin?: string | null;
    preferred_markets?: string[] | null;
  };
  role_profile: {
    birth_date?: string | null;
  };
};

export type SaveMyProfileApiPayload = {
  first_name: string;
  last_name: string;
  email: string;
  phone: string;
  photo_url?: string | null;
  birth_date?: string | null;
  city?: string | null;
  state?: string | null;
  zip_code?: string | null;
  address: string;
  linkedin?: string | null;
  preferred_markets?: string[];
};

export const mapSaveMyProfilePayloadToRequest = (
  payload: SaveMyProfileApiPayload
) => ({
  user: {
    first_name: payload.first_name,
    last_name: payload.last_name,
    email: payload.email,
    phone: payload.phone,
    photo_url: payload.photo_url ?? null,
  },
  profile: {
    city: payload.city ?? null,
    state: payload.state ?? null,
    zip_code: payload.zip_code ?? null,
    address: payload.address,
    linkedin: payload.linkedin ?? null,
    preferred_markets: payload.preferred_markets ?? [],
  },
  role_profile: {
    birth_date: payload.birth_date ?? null,
  },
});

export const mapMyProfileResponseToMyProfile = (
  profile: MyProfileResponse
): MyProfile => ({
  id: profile.user.id,
  first_name: profile.user.first_name || '',
  last_name: profile.user.last_name || '',
  photo_url: profile.user.photo_url || '',
  birth_date: profile.role_profile.birth_date || '',
  city: profile.profile.city || '',
  state: profile.profile.state || '',
  zip_code: profile.profile.zip_code || '',
  address: profile.profile.address || '',
  phone: profile.user.phone || '',
  email: profile.user.email || '',
  linkedin: profile.profile.linkedin || '',
  preferred_markets: profile.profile.preferred_markets || [],
  user_role: profile.user.role || undefined,
});
